import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-five-lesson-five-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFiveLessonFiveGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 5, Lesson 5 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 5: Action Plan for Self-Advocacy and Independent Living";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
